module.exports = __webpack_public_path__ + "static/structure-3d-projects-880x880-1e573a5c9c6c1f36b3a88771f2042f70.png";